import 'jquery-bar-rating/themes/css-stars.less';
import Smooth from 'smooth-scrolling';
import PubSub from 'pubsub-js';
import classes from 'dom-classes';
import {LoadMaskImage, animateChildren} from '../helpers';

require('jquery-bar-rating');

import {MatchHeight} from '../helpers';

export default class VacancyScroll {
    constructor($el) {
        this.el = $el;
        this.section = this.el[0];
        this.maskImageCache = null;
        this.animate = Array.prototype.slice.call(this.section.getElementsByClassName('animate-children') || [], 0);
        this.formWrapper = $('.vacancy-detail__black-background');        
        this.header = $('#siteHeader');
        this.maskImages = Array.prototype.slice.call(this.section.getElementsByClassName('mask-image') || [], 0);        
        
        this.animate.forEach((el, index) => {
            animateChildren(el);
        });

        this.formWrapper.find('#rate-yourself-24').barrating({
            theme: 'css-stars'
          });

        $(window).on('scroll', () => {
            if(this.formWrapper.length && $(window).scrollTop() > this.formWrapper.offset().top - 50) {
                this.header.addClass('inverse');
            }
            else {
                this.header.removeClass('inverse');                
            }
        });

        this.maskImages.forEach(function(element) {
            LoadMaskImage(element);
        }, this);
    }
}


class CustomScroll extends Smooth {
    constructor(opt) {
        super(opt);
        this.animateCache = null;

        this.dom.section = opt.section[0];
        this.dom.animate = Array.prototype.slice.call(this.dom.section.getElementsByClassName('animate-children') || [], 0);
        this.dom.topMenu = opt.topMenu;
        this.dom.formWrapper = $('.vacancy-detail__black-background');
        this.dom.maskImages = Array.prototype.slice.call(this.dom.section.getElementsByClassName('mask-image') || [], 0);
        console.log(this.dom.maskImages);
        
        window.smoothScrollInstances.push(this);
        this.hijackVirtualScroll();
    }

    createExtraBound() {
        ['getCache', 'inViewport', 'loadImage', 'animate', 'init', 'cacheVisuals', 'calc', 'run', 'hijackVirtualScroll']
        .forEach((fn) => this[fn] = this[fn].bind(this));
    }

    hijackVirtualScroll() {
        $(document).on('focus', 'input, textarea', () => {
            if (!window.smoothScrollInstances.length) return;
            window.smoothScrollInstances[0].off();
        }).on('blur', 'input, textarea', () => {
            if (!window.smoothScrollInstances.length) return;
            window.smoothScrollInstances[0].on();
        });
    }

    run() {
        super.run();

        if(this.vars.current > window.innerHeight && this.vars.current < this.previousScroll && !classes.has(this.dom.topMenu, 'active')) {
            classes.add(this.dom.topMenu, 'sticky');
        } else {
            classes.remove(this.dom.topMenu, 'sticky');
        }
        this.dom.maskImages.forEach(this.loadImage);

        this.previousScroll = this.vars.current;
        
        this.dom.animate.forEach(this.animate.bind(this));

        this.dom.section.style[this.prefix] = this.getTransform(this.vars.current * -1);
    }

    calc(e) {
        e.originalEvent.preventDefault();

        const delta = e.deltaY;
        this.vars.target += -(delta / 5);
        this.clampTarget();
    }

    resize() {
        this.resizing = true;

        super.resize();

        super.calc({
            deltaX: 0,
            deltaY: 0
        });

        this.getCache();

        this.dom.formWrapper.height('auto');
        this.dom.formWrapper.height(this.dom.formWrapper.height());

        this.vars.bounding = this.dom.section.getBoundingClientRect().height - this.vars.height;
        this.resizing = false;
    }

    getCache() {

        this.animateCache = [];
        this.dom.animate.forEach((el, index) => {
            el.style.opacity = 0;

            const scrollY = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                top: bounding.top + scrollY,
                left: bounding.left,
                center: bounding.height / 2,
                bottom: bounding.bottom + scrollY
            };

            this.animateCache.push(bounds);
        });


        this.maskImageCache = [];
        this.dom.maskImages.forEach((el, index) => {
            el.style.display = 'block';

            el.getElementsByClassName('mask--image-mask')[0].style.backgroundColor = this.accentColor;

            const scrollY = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                top: bounding.top + scrollY,
                left: bounding.left,
                center: bounding.height / 2,
                bottom: bounding.bottom + scrollY
            };
            this.maskImageCache.push(bounds);
        });
        
        // get bounding value based on the container (.vs-section) height        
        this.vars.bounding = this.dom.section.getBoundingClientRect().height - (this.vars.native ? 0 : this.vars.height);
    }

    loadImage(el, index) {
        console.log('mask image cache');
        if(!this.maskImageCache || this.resizing) return;
        
        const cache = this.maskImageCache[index];
        const current = this.vars.current;
        
        const transform = ((cache.top + cache.center) - current) * cache.speed;
        // const top = Math.round((cache.top + transform) - current)
        const top = Math.round(cache.top - window.innerHeight);
        const bottom = Math.round((cache.bottom + transform) - current);
        const inview = current >= top && current <= cache.bottom;

        if(inview) {         
            LoadMaskImage(el);
            this.maskImageCache.splice(index, 1);
            this.dom.maskImages.splice(index, 1);
        }
    }

    animate(el, index) {
        
        if(!this.animateCache || this.resizing) return;
        
        const cache = this.animateCache[index];
        const current = this.vars.current;
        
        const transform = ((cache.top + cache.center) - current) * cache.speed;
        // const top = Math.round((cache.top + transform) - current)
        const top = Math.round(cache.top - window.innerHeight);
        const bottom = Math.round((cache.bottom + transform) - current);
        const inview = current >= top && current <= cache.bottom;
        if(inview) {         
            animateChildren(el);
            this.animateCache.splice(index, 1);
            this.dom.animate.splice(index, 1);
        }
    }
}


// WEBPACK FOOTER //
// ./app/components/scrolling/vacancy-scroll.js